import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue-dep49';
import Header from './Header.vue'
import Footer from './Footer.vue'

Vue.use(BootstrapVue);

new Vue({
  el: '#header-dep',
  render: function (h) {
  	return h(Header)
  }
})

new Vue({
  el: '#footer-dep',
  render: function (h) {
  	return h(Footer)
  }
})



// WEBPACK FOOTER //
// ./src/main.js